export default "__VITE_ASSET__DLzHQAS8__"